import { PanelLeftIcon } from 'lucide-react';
import { Button } from '@monksflow/monks-ui';

export interface AnalysisRailToggleProps {
  /** Accessible name and tooltip; differs by direction (collapse vs re-open). */
  label: string;
  onClick: () => void;
}

/**
 * The rail's collapse/re-open control. One component for both directions so the
 * two sit at identical size and tone — the collapsed one renders in the content
 * area, where the rail has no width left to hold it.
 */
export const AnalysisRailToggle = ({ label, onClick }: AnalysisRailToggleProps) => (
  <Button
    variant="ghost"
    size="icon"
    className="size-8 cursor-pointer text-muted-foreground"
    aria-label={label}
    title={label}
    onClick={onClick}
  >
    <PanelLeftIcon className="size-4" />
  </Button>
);
